import { z } from 'zod'
import { oc } from '@orpc/contract'
import { copayStatusSchema } from './copay-status.contract'

/*
 * The patient's own side of the self-pay visit fee (PD-1943). All three hang off
 * `/v2/patient/me/…` — see patient-visits.contract.ts for why the `me` segment is load-bearing.
 * Staff keep the `/v2/copay/*` routes; these answer only for the caller's own visit.
 */

/** The fee shown on the Coverage step, before any clinic is known. */
export const patientSelfPayFee = oc
  .route({ method: 'GET', path: '/v2/patient/me/self-pay-fee' })
  .input(z.object({}))
  .output(
    z.object({
      amountCents: z.number().int(),
      /** True when clinics charge different fees and this is their mean. */
      approximate: z.boolean(),
    }),
  )

/** An Embedded Checkout session for the caller's own self-pay visit. */
export const patientSelfPayCheckout = oc
  .route({ method: 'POST', path: '/v2/patient/me/visits/{encounterId}/self-pay/checkout' })
  .input(z.object({ encounterId: z.string().min(1) }))
  .output(
    z.object({
      clientSecret: z.string(),
      /** The clinic's Stripe publishable key, for mounting the embedded form. */
      publishableKey: z.string(),
    }),
  )

/** The same shape the console panel reads, reconciled with Stripe while a session is open. */
export const patientSelfPayStatus = oc
  .route({ method: 'GET', path: '/v2/patient/me/visits/{encounterId}/self-pay/status' })
  .input(z.object({ encounterId: z.string().min(1) }))
  .output(copayStatusSchema)
